import React from 'react';
import { Skeleton } from '../../../components/ui/Skeleton';
import styles from './ConfigurationSkeleton.module.css';

/**
 * Loading placeholders for the configuration tab — shown inside the
 * page's real chrome (the section sidebar renders immediately).
 *
 * ConfigurationSkeleton (default) — form shape for the main
 * `loading && !config` gate: section title + label/field pairs.
 * ConfigListSkeleton — stacked row shape for the on-demand sections
 * (VersionHistory, AuditLog).
 */
export default function ConfigurationSkeleton() {
  return (
    <div className={styles.root} aria-hidden="true">
      <Skeleton className={styles.title} />
      {Array.from({ length: 4 }).map((_, i) => (
        <div className={styles.field} key={i}>
          <Skeleton className={styles.label} />
          <Skeleton className={styles.control} />
        </div>
      ))}
    </div>
  );
}

export function ConfigListSkeleton() {
  return (
    <div className={styles.root} aria-hidden="true">
      <Skeleton className={styles.title} />
      {Array.from({ length: 5 }).map((_, i) => (
        <Skeleton className={styles.row} key={i} />
      ))}
    </div>
  );
}
